import { render, staticRenderFns } from "./RevenueTrendChart.vue?vue&type=template&id=32aa51d4&scoped=true&"
import script from "./RevenueTrendChart.vue?vue&type=script&lang=js&"
export * from "./RevenueTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./RevenueTrendChart.vue?vue&type=style&index=0&id=32aa51d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa51d4",
  null
  
)

export default component.exports